<template>
  <div>
    <div class="d-flex mb-3 align-items-end">
      <h1 class="h4 primary--text">
        {{ $t('navigation.requests') }}
      </h1>
      <div class="ml-auto">
        <v-btn
          outlined
          large
          @click="createRequestModal = true"
        >
          <v-icon left>
            mdi-plus
          </v-icon>
          {{ $t('common.create_request') }}
        </v-btn>
      </div>
    </div>
    <v-data-table
      class="row-clickable"
      fixed-header
      :headers="headers"
      :items="items"
      :footer-props="{
        itemsPerPageOptions: [10, 20, 50, 100],
      }"
      :options.sync="options"
      :server-items-length="total"
      :loading="loading"
      :loading-text="$t('common.loading_data')"
      @click:row="goTo"
    >
      <template v-slot:item.comment="{ item }">
        <span
          class="request-comment"
        >
          {{ item.comment | truncate(200) }}
        </span>
      </template>
    </v-data-table>
    <create-request-modal
      v-model="createRequestModal"
      @submit="onCreateRequestSubmit"
    />
  </div>
</template>

<script>
import CreateRequestModal from '@/components/requests/CreateRequestModal';

export default {
  name: 'RequestList',
  components: {
    CreateRequestModal,
  },
  filters: {
    truncate(text, length, suffix = '...') {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      }
      return text;
    },
  },
  data() {
    return {
      createRequestModal: false,
      total: 0,
      items: [],
      loading: false,
      options: {
        page: 1,
        sortBy: ['date'],
        sortDesc: [true],
      },
      headers: [
        {
          text: this.$t('common.orders.creation_date'),
          value: 'date',
        },
        {
          text: this.$t('common.request_number'),
          value: 'number',
        }, {
          text: this.$t('common.subject'),
          value: 'subject',
        },
        {
          text: this.$t('common.request_type'),
          value: 'type',
        },
        {
          text: this.$t('common.comment'),
          value: 'comment',
        },
        {
          text: this.$t('common.status'),
          value: 'status',
        },
        {
          text: this.$t('common.status_date'),
          value: 'statusDate',
        },
        {
          text: this.$t('common.originator'),
          value: 'createdBy.login',
        },
      ],
    };
  },
  computed: {
    params() {
      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.options;

      const params = {
        populate: ['createdBy', 'comments.author'],
      };

      if (itemsPerPage !== -1) {
        params.pageSize = itemsPerPage;
        params.page = page;
      }

      if (sortBy && sortBy.length) {
        params.sort = `${sortDesc[0] ? '-' : ''}${sortBy[0]}`;
      }

      return params;
    },
  },
  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
  },
  methods: {
    async getItems() {
      this.loading = true;

      const { data } = await this.$http.get('requests', { params: this.params }).finally(() => {
        this.loading = false;
      });

      if (data.rows.length) {
        this.items = data.rows.map((it) => {
          const status = it.statusHistory.reverse().shift();
          const comment = it.comments.reverse().shift();
          const req = {
            ...it,
            comment: comment.message,
            type: this.$t(`enums.request_types.${comment.type}`),
            statusDate: status.date && this.$moment(status.date).format('L LT'),
            date: it.date && this.$moment(it.date).format('L LT'),
            deliveryDate: it.deliveryDate && this.$moment(it.date).format('L LT'),
            status: it.status && this.$t(`enums.request_statuses.${it.status.toLowerCase()}`),
          };
          return req;
        });
      } else {
        this.items = data.rows;
      }

      this.total = data.total;
    },
    goTo({ id }) {
      this.$router.push(`/requests/${id}`);
    },
    onCreateRequestSubmit() {
      this.getItems();
      this.createRequestModal = false;
    },
  },
};
</script>

<style lang="scss">
.row-clickable tr {
  cursor: pointer;
}

.request-comment {
  word-break: break-all;
  max-width: 300px !important;
  display: block;
  overflow: hidden;
}
</style>
